<template>
  <div class="language">
    <div>
      <van-nav-bar fixed placeholder :title="$t('nav.language')">
        <template #left>
          <van-icon @click="navTo('/')" color="#000" name="arrow-left" />
        </template>
      </van-nav-bar>
    </div>

    <div class="content-section">
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell class="cell-radio" :title="$t('language.en')" clickable @click="radio = '3'">
            <template #right-icon>
              <van-radio name="3" />
            </template>
          </van-cell>
          <van-cell class="cell-radio" :title="$t('language.jp')" clickable @click="radio = '4'">
            <template #right-icon>
              <van-radio name="4" />
            </template>
          </van-cell>
          <van-cell class="cell-radio" :title="$t('language.ko')" clickable @click="radio = '5'">
            <template #right-icon>
              <van-radio name="5" />
            </template>
          </van-cell>
          <van-cell class="cell-radio" :title="$t('language.da')" clickable @click="radio = '6'">
            <template #right-icon>
              <van-radio name="6" />
            </template>
          </van-cell>
          <van-cell class="cell-radio" :title="$t('language.po')" clickable @click="radio = '7'">
            <template #right-icon>
              <van-radio name="7" />
            </template>
          </van-cell>
          <van-cell class="cell-radio" :title="$t('language.es')" clickable @click="radio = '8'">
            <template #right-icon>
              <van-radio name="8" />
            </template>
          </van-cell>
          <van-cell class="cell-radio" :title="$t('language.cn')" clickable @click="radio = '1'">
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell>
          <van-cell class="cell-radio" :title="$t('language.tcn')" clickable @click="radio = '2'">
            <template #right-icon>
              <van-radio name="2" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <div style="margin: 16px">
          <van-button round block type="info" native-type="submit" @click="onChangeLang"
            >{{ $t('button.language') }}</van-button
          >
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "language",
  data() {
    return {
      radio: '1',
      url: '/'
    };
  },
  created() {
    this.getLang();
    const id = this.$route.params && this.$route.params.id;
    this.url = id == 2 ? "/account": "/"
  },
  methods: {
    onChangeLang() {
      let lang = this.$i18n.locale;
      switch(this.radio) {
        case '1': lang = 'cn';localStorage.setItem('lang',lang);break;
        case '2': lang = 'tcn';localStorage.setItem('lang',lang);break;
        case '3': lang = 'en';localStorage.setItem('lang',lang);break;
        case '4': lang = 'jp';localStorage.setItem('lang',lang);break;
        case '5': lang = 'ko';localStorage.setItem('lang',lang);break;
        case '6': lang = 'da';localStorage.setItem('lang',lang);break;
        case '7': lang = 'po';localStorage.setItem('lang',lang);break;
        case '8': lang = 'es';localStorage.setItem('lang',lang);break;
      }
      this.$router.push('/')
      window.location.reload()
    },
    getLang() {
      let lang = this.$i18n.locale;
      switch(lang) {
        case 'cn': this.radio = '1'; 
        break;
        case 'tcn' : this.radio = '2';
        break;
        case 'en':this.radio = '3';
        break;
        case 'jp': this.radio = '4';
        break;
        case 'ko': this.radio = '5';
        break;
        case 'da': this.radio = '6';
        break;
        case 'po': this.radio = '7';
        break;
        case 'es': this.radio = '8';
        break;
      }
    },
    navTo() {
      this.$router.push(this.url);
    }
  }
};
</script>

<style>
.content-section {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
  margin: 0 10px 10px 10px;
}

.cell-radio {
  padding: 10px;
  margin: 10px 0 10px 0;
  text-align: left;
}
</style>
